import { useMemo, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { deleteHeader, getHeaders } from '../../../../../api/endpoints/cmsSite';
import type { Header } from '../../../../../api/types/cmsSite';
import { ConfirmDialog } from '../../../../../components/ConfirmDialog';
import {
  ListPageScaffold,
  RowActions,
  useDeleteResource,
  type DataTableColumn,
} from '../../../../../components/common';
import { HeaderFormDialog } from '../HeaderFormDialog';

export default function HeaderListPage({ siteId }: { siteId: number }) {
  const [createOpen, setCreateOpen] = useState(false);
  const [editing, setEditing] = useState<Header | null>(null);

  const query = useQuery({ queryKey: ['cms', 'headers', siteId], queryFn: () => getHeaders(siteId) });
  const rows: Header[] = useMemo(() => query.data?.headers ?? [], [query.data]);

  const del = useDeleteResource<number>({
    mutationFn: (id) => deleteHeader(id),
    invalidateKeys: [['cms', 'headers']],
    successMessage: 'Header silindi.',
  });

  const columns: DataTableColumn<Header>[] = [
    { id: 'title', header: 'Başlık', cell: (r) => r.title ?? '—' },
    { id: 'slogan', header: 'Slogan', cell: (r) => r.slogan ?? '—' },
    { id: 'facebook', header: 'Facebook', cell: (r) => r.facebook ?? '—' },
    { id: 'twitter', header: 'Twitter', cell: (r) => r.twitter ?? '—' },
    { id: 'instagram', header: 'Instagram', cell: (r) => r.instagram ?? '—' },
  ];

  return (
    <ListPageScaffold
      title="Header"
      headerVariant="section"
      createLabel="Yeni Header"
      onCreate={() => setCreateOpen(true)}
      query={query}
      rows={rows}
      columns={columns}
      getRowKey={(r) => r.id}
      emptyTitle="Kayıtlı header bulunamadı."
      rowActions={(r) => <RowActions onEdit={() => setEditing(r)} onDelete={() => del.request(r.id)} />}
    >
      <HeaderFormDialog open={createOpen} header={null} siteId={siteId} onClose={() => setCreateOpen(false)} />
      <HeaderFormDialog open={!!editing} header={editing} siteId={siteId} onClose={() => setEditing(null)} />
      <ConfirmDialog
        {...del.confirmDialogProps}
        title="Header'ı sil"
        description="Bu header kaydını silmek istediğinize emin misiniz?"
      />
    </ListPageScaffold>
  );
}
